import {Component, OnInit} from '@angular/core';
import {firstValueFrom} from "rxjs";

import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";
import {getCookie, removeCookie, setCookie} from "typescript-cookie";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CommonModule, JsonPipe } from '@angular/common';
import { AlertComponent } from 'src/app/components/alert/alert.component';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    standalone: true,
    imports: [FaIconComponent, CommonModule, JsonPipe, AlertComponent]
})
export class AuthCallbackComponent implements OnInit {

  loading: boolean = true ;
  error?: any ;

  constructor(
    private users: UserService,
    private router: Router
  ) { } ;

  
  async ngOnInit() {

    await this.finaliseAndRedirect();
  }

  
  async finaliseAndRedirect() {

    try {

      let user = await firstValueFrom(this.users.updateCurrentUser());
      console.log(user);

      
      let returnUrl = getCookie("AUTH_RETURN_URL") ;

      if (returnUrl && returnUrl != 'undefined') {
        //removeCookie("AUTH_RETURN_URL") ;
        await this.router.navigateByUrl(returnUrl);
      } else {
        await this.router.navigateByUrl('/');
      }

    } catch (error) {
      this.error = error ;
      console.log('error finalizing sign up', error);
    }

    this.loading = false ;
  }

}
